/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AnoExperienciaEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const AnoExperienciaEnum = {

    NUMBER_1: 1 as AnoExperienciaEnum,

    NUMBER_2: 2 as AnoExperienciaEnum,

    NUMBER_3: 3 as AnoExperienciaEnum,

    NUMBER_4: 4 as AnoExperienciaEnum,

    NUMBER_5: 5 as AnoExperienciaEnum,

    NUMBER_6: 6 as AnoExperienciaEnum,

    NUMBER_7: 7 as AnoExperienciaEnum
};

